import PageHero from "@/components/base/PageHero";
import LegalBlock from "@/components/base/LegalBlock";
import { company } from "@/mocks/site";

export default function Impressum() {
  return (
    <>
      <PageHero
        label="Rechtliches"
        title="Impressum"
        lead="Angaben gemäß den gesetzlichen Anforderungen an Anbieterkennzeichnung und Hinweise zu Haftung und Urheberrecht."
      />

      <section className="bg-background-50 py-10 md:py-16">
        <div className="mx-auto w-full max-w-shell px-4 md:px-6">
          <div className="max-w-3xl">
            <LegalBlock title="Verantwortlich für den Inhalt">
              <p className="font-heading text-[14.5px] font-bold text-foreground-950">{company.name}</p>
              <p>
                {company.street}
                <br />
                D-{company.zip} {company.city}
                <br />
                {company.region}, {company.country}
              </p>
              <dl className="grid grid-cols-1 gap-x-6 gap-y-1.5 font-label text-[12px] sm:grid-cols-2">
                <div>
                  <dt className="inline text-foreground-500">Telefon: </dt>
                  <dd className="inline">{company.phone}</dd>
                </div>
                <div>
                  <dt className="inline text-foreground-500">Telefax: </dt>
                  <dd className="inline">{company.fax}</dd>
                </div>
                <div>
                  <dt className="inline text-foreground-500">E-Mail: </dt>
                  <dd className="inline">
                    <a href={`mailto:${company.email}`} className="text-primary-700 underline underline-offset-2">
                      {company.email}
                    </a>
                  </dd>
                </div>
                <div>
                  <dt className="inline text-foreground-500">Geschäftsführer: </dt>
                  <dd className="inline">{company.manager}</dd>
                </div>
                <div>
                  <dt className="inline text-foreground-500">Register: </dt>
                  <dd className="inline">{company.register}</dd>
                </div>
                <div>
                  <dt className="inline text-foreground-500">USt-IdNr.: </dt>
                  <dd className="inline">{company.vat}</dd>
                </div>
              </dl>
            </LegalBlock>

            <LegalBlock title="Copyright">
              <p>
                Alle auf dieser Website befindlichen Inhalte sind urheberrechtlich geschützt. Eine
                auch nur teilweise Vervielfältigung oder Verwendung der Inhalte in anderen
                elektronischen oder gedruckten Medien ist ohne ausdrückliche und schriftliche
                Zustimmung nicht gestattet.
              </p>
            </LegalBlock>

            <LegalBlock title="Haftungshinweis">
              <p>
                Trotz sorgfältiger inhaltlicher Kontrolle übernehmen wir keine Haftung für die
                Inhalte externer Links. Für den Inhalt der verlinkten Seiten sind ausschließlich
                deren Betreiber verantwortlich.
              </p>
            </LegalBlock>

            <LegalBlock title="Bildnachweise">
              <p>
                Produkt- und Anlagenaufnahmen stammen aus dem eigenen Unternehmen. Eine Nutzung der
                Abbildungen außerhalb dieser Website ist nur mit schriftlicher Genehmigung zulässig.
              </p>
            </LegalBlock>
          </div>
        </div>
      </section>
    </>
  );
}